export const SALES_MANAGER_CODE = 'GV';
export const OPERATIONS_DIRECTOR_CODE = 'DO';
export const QUALITY_MANAGER_CODE = 'JCS';
export const SUPER_USER_CODE = 'SU';
export const CLIENT_CODE = 'CL';
export const SALES_EXECUTIVE_CODE = 'EV';

